import { typeCreatorV2 } from '../../../redux/utils/common';

//  [REDUCER][TYPE]
export const SET_NOTIFICATION_LIST: string = typeCreatorV2(
  'NotificationReducer',
  'SetNotificationList'
);

export const SET_ADD_NOTIFICATION: string = typeCreatorV2(
  'NotificationReducer',
  'SetAddNotification'
);

export const SET_EDIT_NOTIFICATION: string = typeCreatorV2(
  'NotificationReducer',
  'SetEditNotification'
);

export const SET_NOTIFICATION_DETAIL: string = typeCreatorV2(
  'NotificationReducer',
  'SetNotificationDetail'
);

export const SET_REMINDER_LIST: string = typeCreatorV2(
  'NotificationReducer',
  'SetReminderList'
);

export const SET_NOTIFICATION_VIEW: string = typeCreatorV2(
  'NotificationReducer',
  'SetNotificationView'
);

export const SET_UNREAD_NOTIFICATION_COUNT: string = typeCreatorV2(
  'NotificationReducer',
  'SetUnreadNotificationCount'
);
